module.exports = "/assets/f4675059bcf164c15dd719122f9f4ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JB.png
// module id = 1504
// module chunks = 0